import moment from "moment";

/**
 * A reading "exists" when it is neither null, undefined nor '', and coerces to a
 * finite number. Zero counts as a reading.
 */
export function hasReading(value) {
    if (value === null || value === undefined || value === '') {
        return false;
    }

    return Number.isFinite(Number(value));
}

/**
 * Derives which due-lines a maintenance row can show, and their values.
 *
 * Gates on the schedule flag plus the availability of the readings the figure needs
 * — not on which asset id is set. Trucks always have Hours: null, so an hours line
 * can never appear for a truck; trailers that report mileage now get an odometer
 * line, which the previous TruckID gate suppressed.
 *
 * `now` exists only so the date arithmetic is deterministic under test.
 */
export function getDueReadings(item, now = moment()) {
    const showOdometer = !!item?.IsByOdometer
        && hasReading(item?.Mileage)
        && hasReading(item?.LastOdometerRun)
        && hasReading(item?.OdometerInterval);

    const showHours = !!item?.IsByHours
        && hasReading(item?.Hours)
        && hasReading(item?.LastHoursRun)
        && hasReading(item?.HoursInterval);

    const dateDueIn = item?.LastDateRun
        ? moment(item.LastDateRun).add(Number(item.DateInterval) || 0, "days").diff(now, 'days')
        : null;

    return {
        showDate: !!item?.IsByDate && dateDueIn !== null,
        showOdometer: showOdometer,
        showHours: showHours,
        dateDueIn: dateDueIn,
        odometerDue: showOdometer
            ? (Number(item.LastOdometerRun) + Number(item.OdometerInterval)) - Number(item.Mileage)
            : null,
        hoursDue: showHours
            ? (Number(item.LastHoursRun) + Number(item.HoursInterval)) - Number(item.Hours)
            : null
    };
}
